export default __webpack_public_path__ + "static/media/trr-drink-juicecocktail-berrycherry.977fe97a.png";